import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ROUTES } from 'config';
import { error } from 'static/icons/resizable';
import * as S from './Forbidden.styles';

export const Forbidden = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <S.PageWrapper>
      <S.Content>
        <S.ErrorIcon src={error} />
        <S.TitleText data-testid='Forbidden-Title' kind='h2'>{t('forbiddenPage.title')}</S.TitleText>
        <S.DescriptionText data-testid='Forbidden-AlertMessage' kind='body'>
          {t('forbiddenPage.description')}
        </S.DescriptionText>
        <S.BackButton data-testid='Forbidden-MainPageButton' kind='primary' onClick={() => navigate(ROUTES.main)}>
          {t('forbiddenPage.buttonText')}
        </S.BackButton>
      </S.Content>
    </S.PageWrapper>
  );
};
